import axios from "axios";
import Config from "../Config";
import ErrorMessage from "../libs/helpers/ErrorMessage";

export const getBrandDetailApi = async ({ headers, id }) => {
  try {
    const res = await axios.get(
      `${Config.apiBaseurl}/${Config.apis.frontend.api}/brand/${id}`,
      {
        headers,
      },
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};
